
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-thumb-hundred/[date]",
      function () {
        return require("private-next-pages/top-thumb-hundred/[date].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-thumb-hundred/[date]"])
      });
    }
  